module.exports = __webpack_public_path__ + "media/images/rank/regular-977bc3b4bab220150ff1bd177d4c14bb.png";